import { Six_To_12_Options } from './../../../../shared/constants/mad-libs/dimension1-options/6-to-12-options.constant';
import { Six_to_8_Options } from './../../../../shared/constants/mad-libs/dimension1-options/6-to-8-options.constant';
import { Nine_To_12_Options } from './../../../../shared/constants/mad-libs/dimension1-options/9-to-12-options.constant';
import { K_to_5_Options } from './../../../../shared/constants/mad-libs/dimension1-options/k-to-5-options.constant';
import { K_To_8_Options } from './../../../../shared/constants/mad-libs/dimension1-options/k-to-8-options.constant';

import {
  admitDate,
  assignedSupports,
  currentYtd,
  flags,
  lastYearOverAll,
  lastYearYtd,
  past20Days,
  past5Days,
  studentName,
  supports,
  thisTerm,
  today,
  yearlyChange,
} from './attendance-mad-lib-columns.constant';

import { IAttendanceDimension } from './attendance-mad-lib.interface';

export const DIMENSION_1 = {
  // Filter dimension
  madLib: 'Dimension1',
  options: {
    'K to 5': K_to_5_Options,
    'K to 8': K_To_8_Options,
    '6 to 8': Six_to_8_Options,
    '6 to 12': Six_To_12_Options,
    'Large HS': Nine_To_12_Options,
    'Small HS': Nine_To_12_Options,
    Charter: Nine_To_12_Options,
    Transfer: Nine_To_12_Options,
  },
  helperText: 'focused on',
};

export const DIMENSION_2: IAttendanceDimension = {
  madLib: 'Dimension2',
  options: [
    {
      human: 'Today',
      key: 'TODAY',
      columns: {
        0: studentName,
        5: lastYearOverAll,
        10: currentYtd,
        20: today,
        30: supports,
        40: flags,
      },
    },

    {
      human: '5 days',
      key: '5_DAYS',
      columns: {
        0: studentName,
        5: lastYearOverAll,
        10: currentYtd,
        20: past5Days,
        30: supports,
        40: flags,
      },
    },

    {
      human: '20 days',
      key: '20_DAYS',
      columns: {
        0: studentName,
        5: lastYearOverAll,
        10: currentYtd,
        20: past20Days,
        30: supports,
        40: flags,
      },
    },

    {
      human: 'This term',
      key: 'THIS_TERM',
      columns: {
        0: studentName,
        5: lastYearOverAll,
        10: currentYtd,
        20: thisTerm,
        30: supports,
        40: flags,
      },
    },

    {
      human: 'This year',
      key: 'THIS_YEAR',
      columns: {
        0: studentName,
        5: lastYearOverAll,
        10: lastYearYtd,
        20: currentYtd,
        30: yearlyChange,
        40: flags,
      },
    },
  ],
  helperText: 'grouped by',
};

export const GROUPING = {
  madLib: 'Groupings',
  options: [
    {
      human: 'Trend',
      key: 'TREND',
      columns: {},
    },
    {
      human: 'DOE risk group (Att)',
      key: 'RISK_GROUP',
      columns: {},
    },
    {
      human: 'Support',
      key: 'SUPPORT',
      columns: {
        30: assignedSupports,
        40: flags,
      },
    },
    {
      human: 'Admit date',
      key: 'ADMIT',
      columns: { 5: admitDate },
    },
    {
      human: 'Flag type',
      key: 'FLAG',
      columns: {},
    },
  ],
};

export const ATTENDANCE_MAD_LIB: IAttendanceDimension[] = [DIMENSION_1, DIMENSION_2, GROUPING];

// Needed to generate madlib State within resolve blocks
export const ATTENDANCE_MADLIB_CONFIG = {
  DIMENSION_1,
  DIMENSION_2,
  GROUPING,
  listType: 'ATTENDANCE',
  dimensionsAreIndependent: true,
  hasDimensionParams: $stateParams => {
    const { Dimension1, Dimension2, Groupings } = $stateParams;
    const hasDimensionParams = !!(Dimension1 && Dimension2 && Groupings);
    return hasDimensionParams;
  },
};
